module.exports = __webpack_public_path__ + "static/media/slider-top.f58f41f4.JPG";